import { transient } from "aurelia-framework";
import { RulesClientService } from "../../../../../services/rules/rules-client.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";

@transient()
export class BusinessUnitRuleRiskDialog {

    private ruleConfigs: {ruleCollectionRuleConfigId:number, ruleCollectionId:number, businessUnitId:number}[];

    defaultRiskLevel: string;
    defaultRiskLevelId: number;

    riskCategoryId: number;
    riskLevelId: number;
    riskLevel: string;
    reload: (()=> void);

    activate(model: { reload:(()=> void),
        ruleConfigs: {ruleCollectionRuleConfigId:number, ruleCollectionId:number, businessUnitId:number}[], defaultRiskLevel: string, riskCategoryId:number, defaultRiskLevelId: number, overriddenRiskLevel?: string, overriddenRiskLevelId: number
    }) {
        this.ruleConfigs = model.ruleConfigs;
        this.riskCategoryId = model.riskCategoryId;
        this.defaultRiskLevel = model.defaultRiskLevel;
        this.defaultRiskLevelId = model.defaultRiskLevelId;
        this.riskLevel = model.overriddenRiskLevel;
        this.riskLevelId = model.overriddenRiskLevelId;
        this.reload = model.reload;
    }

    constructor(private rulesClientService: RulesClientService, private dialogClientService: DialogClientService,
        private notificationClientService: NotificationClientService, private i18N: I18N) {
    }

    async save() {
        try {
            await this.rulesClientService.overrideVettingRisk(this.ruleConfigs, this.riskLevelId, this.riskCategoryId);
            if(this.reload) this.reload();
            this.notificationClientService.show(this.i18N.tr('changes-saved-successfully-text'), '', NotificationType.Success)
            this.dialogClientService.hide();
        } catch {
            this.notificationClientService.show(this.i18N.tr('failed-to-save-text'), '', NotificationType.Error)
        }
    }

    cancel() {
        this.dialogClientService.hide();
    }
}